import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import UILoader from 'components/UI/Loader/Loader';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import NavigationProvider from 'components/Navigation/Provider';
import ScanNavigationProvider from 'components/Navigation/ScanNavigationProvider';
import schema from 'components/Placement/Search/schema';
import { PlacementsQuery } from 'components/Placement/Form/graphql';
import { RoutePrivateProps } from 'components/Route/Private/types';

const PlacementForm = React.lazy(
  () => import('components/Placement/Form/Form'),
);

const listSchema = { ...schema };
delete listSchema.listMode;

function ScreensPlacementForm(params: Readonly<RoutePrivateProps>) {
  const id = params.id ? Number(params.id) : null;
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const isScanContext = urlParams.get('exitUrl')?.startsWith('/scan');

  const buildUrl = (nid: string) => `/placements/${nid}/edit`;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>Edit Placement</DocumentTitle>
      {isScanContext ? (
        <ScanNavigationProvider id={id} buildUrl={buildUrl}>
          <Suspense fallback={<UILoader />}>
            <PlacementForm id={id} key={id} />
          </Suspense>
        </ScanNavigationProvider>
      ) : (
        <NavigationProvider
          id={id}
          buildUrl={buildUrl}
          schema={listSchema}
          query={PlacementsQuery}
        >
          <Suspense fallback={<UILoader />}>
            <PlacementForm id={id} key={id} />
          </Suspense>
        </NavigationProvider>
      )}
    </BaseLayout>
  );
}

export default ScreensPlacementForm;
